import dayjs from 'dayjs';

/** Пороги подсветки сроков из ТЗ: ≤ 1 дня — красный, ≤ 3 — оранжевый. */
export const EXPIRY_RED_DAYS = 1;
export const EXPIRY_ORANGE_DAYS = 3;

/** Дней до конца срока от сегодня (по календарю, без часов): < 0 — просрочено. */
export function daysLeft(expiresOn: string, today = dayjs()): number {
  return dayjs(expiresOn).startOf('day').diff(today.startOf('day'), 'day');
}

export function expiryColor(days: number): string | undefined {
  if (days <= EXPIRY_RED_DAYS) return 'red';
  if (days <= EXPIRY_ORANGE_DAYS) return 'orange';
  return undefined;
}
